import { User } from "../types/multiplayer";
import { getApiUrl } from "./utils";

export const VOLUME = Object.freeze({
    LABELS: ["Mute", "Low", "Medium", "High", "Max"] as const,
});

export const DIFFICULTY = Object.freeze({
    OPTIONS: {
        Easy: 0,
        Medium: 1,
        Hard: 2,
    },
});

export const CustomPiecesConstants = Object.freeze({
    ZOOM_FACTOR: 2.5,
    TILE_WIDTH_OFFSET: 0.7,
    PIECE_DICTIONARY: [
        { piece: "wP" },
        { piece: "wN" },
        { piece: "wB" },
        { piece: "wR" },
        { piece: "wQ" },
        { piece: "wK" },
        { piece: "bP" },
        { piece: "bN" },
        { piece: "bB" },
        { piece: "bR" },
        { piece: "bQ" },
        { piece: "bK" },
    ],
});

export const CustomBoardConstants = Object.freeze({
    AI_RESPONSE_DELAY: 1000,
    ANIMATION_DURATION: 250,
    AI_PROMOTION_TYPE: "bQ",
    KING_SQUARE_INCHECK_STYLES: {
        background:
            "radial-gradient(circle, rgba(255, 0, 0, 0.8) 20%, rgba(255, 0, 0, 0.4) 50%, transparent 80%)",
        animation: "king-flash 1s infinite",
    },
    CAPTURE_MOVE_SQUARE_STYLES: "rgba(255, 0, 0, 0.5) 60%, transparent 70%",
    AVAIL_MOVE_SQUARE_STYLES: "rgba(0, 0, 0, 0.5) 20%, transparent 20%",
});

export const MULTIPLAYER = Object.freeze({
    WS_URL: getApiUrl(),
    RETRY_DELAY: 3000,
    MAX_RECONNECT_RETRIES: 5,
    PING_INTERVAL: 15000,
    LOBBY_STORAGE_KEY: "lobby_multiplayer_session",
    LOBBY_STORAGE_EXPIRATION: 30 * 24 * 60 * 60 * 1000, // thirty days in ms
    LOBBY_ID_KEY: "lobbyId",
    DEFAULT_USERNAME: "Guest",
});

export const INITIAL_PLAYER_OBJECT = {
    userId: "",
    username: "",
    picture: "",
    userStatus: "not_ready",
    color: "w",
    playerNumber: 1,
} satisfies User;

export const WaitingRoomConstants = Object.freeze({
    COPY_DELAY: 2000,
    QR_CODE_CONFIG: {
        erorCorrectionLevel: "L" as const,
        width: 400,
        margin: 2,
        color: {
            dark: "#230C01",
            light: "#d9b996",
        },
    },
});

export const VictoryScreenConstants = Object.freeze({
    VICTORY_SCREEN_DURATION: 5000,
});

export const AFK_TIMEOUT = 120000; // 2mins in milliseconds

export const GameConstants = Object.freeze({});
